import { Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CampaignQuery } from '../campaign'

export type CampaignSortValue = NonNullable<CampaignQuery['sort']>

export const defaultCampaignSort: CampaignSortValue = '-created_at'

const sortOptions: CampaignSortValue[] = ['-created_at', 'created_at', 'title', '-title']

export type CampaignSortProps = {
    value: CampaignSortValue
    onChange: (value: CampaignSortValue) => void
}

export function CampaignSort({ value, onChange }: CampaignSortProps) {
    const { t } = useTranslation()

    const labels: Record<CampaignSortValue, string> = {
        '-created_at': t('Newest first'),
        created_at: t('Oldest first'),
        title: t('Title (A-Z)'),
        '-title': t('Title (Z-A)'),
    }

    return (
        <Select
            size="large"
            value={value}
            onChange={onChange}
            style={{ width: 170 }}
            options={sortOptions.map((option) => ({ value: option, label: labels[option] }))}
        />
    )
}
